module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACQAAAAkCAYAAADhAJiYAAAAdklEQVR42u3WwQ1AMBiGYYmDDsE+pukENrCMC7GHI2bhlzRCD476kfdNvqTH59Q2y4iI/lcdpoHx3m/HFFAnJoAmW66CmW2lCmYB84CpVDArmEtdBGpT3zfONkaoBhQoUG+j7NynfO1vKNtgK1Q+aU4JQ0T0+XYKwX6IHMu5RQAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/img/pdf-viewer/arrow_left.png
// module id = 466
// module chunks = 438